import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPartRequestDetails } from "../../reduxStore/entities/partRequest";
import EngineDisplacementSVG from "../../assets/icons/svg/EngineDisplacementSVG";
import ThumbUpSVG from "../../assets/icons/svg/ThumbUpSVG";
import ThumbDownSVG from "../../assets/icons/svg/ThumbDownSVG";
import { partRequestsPartstateOptions } from "../../../../utils/mapRequestStates";
import ChatIconSVG from "../../assets/icons/svg/ChatIconSVG";
import MakeOfferArrowSVG from "../../assets/icons/svg/MakeOfferArrowSVG";
import PowerIconSVG from "../../assets/icons/svg/PowerIconSVG";
import FuelIconSVG from "../../assets/icons/svg/FuelIconSVG";
import CopyIconSVG from "../../assets/icons/svg/CopyIconSVG";
import Breadcrumb from '../../../SharedComponents/components/Breadcrumb/Breadcrumb';
import { getRequestStateLabel } from "../../utils/helpers/getRequestStateLabel";
import { SendMessageFormDisable } from "../RequestComponents/MessageComponents/SendMessageFormDisable"
import { useNavigate } from "react-router-dom";

const PartRequestDetails = ({ id, onBack }) => {
    const [copySuccess, setCopySuccess] = useState(false);
    const dispatch = useDispatch();
    const details = useSelector((state) => state.partRequests.partRequestDetails);
    const [showChat, setShowChat] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            dispatch(getPartRequestDetails({ id: Number(id) }));
        }
    }, [id, dispatch]);

    if (!details) return <div>Učitavanje…</div>;

    const handleCopyVin = () => {
        if (details.vin) {
            navigator.clipboard.writeText(details.vin);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        }
    };

    const stateLabel = getRequestStateLabel(details?.state);

    let breadcrumbs = [
        { title: 'Početak', href: '/home-page' },
        { title: 'Zahtevi za ponude', href: '/request' },
        { title: `Zahtev – ${details.title}`, href: '#' }
    ];

    return (
        <div style={styles.pageWrapper}>
            <div style={styles.header}>
                <h1 style={styles.title}>
                    {`Zahtev – ${details.title}`}
                </h1>

                <div
                    style={{
                        ...styles.stateBadge,
                        backgroundColor: details?.state === 3 ? "red" : "green",
                    }}
                >
                    {stateLabel}
                </div>
            </div>

            <div style={styles.breadcrumbContainer}>
                <Breadcrumb breadcrumbs={breadcrumbs} />
            </div>

            <div style={styles.detailsContainer}>
                <h2 style={styles.detailsTitle}>
                    {details.Make?.name}  <strong>{details.Model?.name}</strong> – {details.Generation?.name?.match(/\d{2}\.\d{4}-\d{2}\.\d{4}/)?.[0] || "Godine nepoznate"}
                </h2>
                <div style={styles.motorInfo}>
                    <span> <EngineDisplacementSVG />{details.Motor?.name}</span>
                    <span> <PowerIconSVG />{details.Motor?.name}</span>
                    <span> <FuelIconSVG />{details.Motor?.name}</span>
                </div>
                <div style={styles.vinContainer}>
                    <p style={styles.vinText}>
                        Broj šasije: <code style={styles.vinCode}>{details.vin || "N/A"}</code>

                        {details.vin && (
                            <span onClick={handleCopyVin} style={styles.copyLink}>
                                <CopyIconSVG /> Kopiraj
                            </span>
                        )}
                    </p>
                    {copySuccess && <p style={styles.copySuccess}>Kopirano!</p>}
                </div>
            </div>

            <div style={styles.imageAndDescription}>
                {details.PartRequestImages?.[0]?.url && (
                    <img
                        src={details.PartRequestImages[0].url}
                        alt="Zahtev slika"
                        style={styles.image}
                    />
                )}

                <div style={styles.descriptionWrapper}>
                    <div style={styles.descriptionHeader}>
                        <h3 style={styles.descriptionTitle}>
                            {details.title?.split(" - ")[0] || "Zadnji branik"} ▪{" "}
                            {
                                partRequestsPartstateOptions().find(opt => opt.value === details.partstate)?.label || "Stanje nepoznato"
                            }
                        </h3>
                        <div style={styles.userInfo}>
                            <p style={styles.userCity}>
                                {details.User?.city || "Nepoznat grad"}
                            </p>
                            <p style={styles.userRatings}>
                                <ThumbUpSVG /> {details.User?.positive_rated_as_buyer || 0}
                                <ThumbDownSVG /> {details.User?.negative_rated_as_buyer || 0}
                            </p>
                        </div>
                    </div>

                    <p style={styles.descriptionText}>
                        {details.description || "Nema opisa"}
                    </p>
                </div>
            </div>

            {details.state == 1 && (
                <div style={styles.buttonGroup}>
                    {!showChat && (
                        <button
                            onClick={() => setShowChat(true)}
                            style={styles.contactButton}
                        >
                            Kontaktiraj korisnika
                            <ChatIconSVG />
                        </button>
                    )}
                    <div style={styles.offerWrapper}>
                        <button
                            style={styles.offerButton}
                            onClick={() => navigate("/create-offer", { state: { id } })}
                        >
                            Napravi ponudu
                            <MakeOfferArrowSVG />
                        </button>
                        <div style={styles.helperText}>
                            U sledećem koraku upiši detalje
                        </div>
                    </div>
                </div>
            )}

            {showChat && (
                <SendMessageFormDisable onClose={() => setShowChat(false)} />
            )}
        </div >
    );
};

export default PartRequestDetails;

const styles = {
    pageWrapper: { padding: 24 },

    header: {
        marginBottom: '8px',
        marginTop: '20px',
        display: "flex",
        alignItems: "center",
        gap: 12
    },

    title: {
        margin: 0,
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "32px",
        fontWeight: 400,
        letterSpacing: "0.2px"
    },

    stateBadge: {
        padding: "4px 10px",
        borderRadius: "999px",
        color: "white",
        fontWeight: 600,
        fontSize: "12px",
        whiteSpace: "nowrap",
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 70,
    },

    breadcrumbContainer: {
        marginBottom: '30px',
    },

    detailsContainer: {
        backgroundColor: "#f8f9fa",
        padding: 16,
        borderRadius: 8,
        display: "flex",
        flexDirection: "column",
        marginBottom: 32,
        border: "1px solid #ccc",
    },

    detailsTitle: {
        margin: 0
    },

    motorInfo: {
        marginTop: 8,
        display: "flex",
        gap: 16,
        flexWrap: "wrap"
    },

    vinContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
        marginTop: 8,
    },

    vinText: { margin: 0 },

    vinCode: { color: "black" },

    copyLink: {
        color: "rgba(91, 33, 182, 1)",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        marginLeft: 8,
    },

    copySuccess: {
        fontSize: 12,
        color: "#888",
        margin: 0,
        marginLeft: 8,
    },

    imageAndDescription: {
        backgroundColor: "#f2efff",
        padding: 16,
        borderRadius: 8,
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 16,
        border: "1px solid #ccc",
    },

    image: {
        width: 100,
        height: 100,
        objectFit: "cover",
        borderRadius: 8
    },

    descriptionWrapper: {
        flex: 1,
        display: "flex",
        flexDirection: "column"
    },

    descriptionHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start"
    },

    descriptionTitle: {
        margin: 0,
        fontWeight: "bold",
        fontSize: 18
    },

    userInfo: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12
    },

    userCity: {
        margin: 0,
        fontWeight: "bold"
    },

    userRatings: {
        margin: 0,
        display: "flex",
        gap: 8,
        alignItems: "center"
    },

    descriptionText: {
        marginTop: 8
    },

    buttonGroup: {
        display: "flex",
        gap: 20,
        marginBottom: 16,
        marginTop: 32,
    },

    contactButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 12,
        border: "2px solid #000",
        backgroundColor: "#fff",
        color: "#000",
        fontWeight: "bold",
        fontSize: 18,
        cursor: "pointer",
        width: 248,
        height: 60
    },

    offerWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },

    offerButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 12,
        border: "none",
        backgroundColor: "#1A1A1A",
        color: "#fff",
        fontWeight: "bold",
        fontSize: 18,
        cursor: "pointer",
        width: 240,
        height: 60
    },

    helperText: {
        marginTop: 8,
        width: 240,
        height: 24,
        color: "rgba(0, 0, 0, 0.87)",
        fontFamily: "TitilliumWeb-Regular, sans-serif",
        fontSize: 16,
        fontWeight: 400,
        textAlign: "center",
        lineHeight: "24px",
    },
};
